import cn from "classnames";
import styles from "./Input.module.sass"
import {forwardRef} from "react";

const inputTypes = {
	input: 'input',
	textarea: 'textarea',
}

const Input = forwardRef(({ inputType = inputTypes.input,
	                          type = 'text',
	                          placeholder = '',
	                          required = false,
	                          className,
	                          onValueChange,}, ref) => {

	return (
			<label
					className={cn(
							styles.input_container,
							className,
					)}
			>
				{inputType === inputTypes.input
						? <input
								ref={ref}
								type={type}
								placeholder={' '}
								onChange={onValueChange}
						/>
						: <textarea
								ref={ref}
								placeholder={' '}
								rows={4}
								onChange={onValueChange}
						/>
				}

				{/*Text*/}
				<span className={styles.text}>{placeholder}{required
						? '*'
						: ''}</span>
			</label>
	)
})
export default Input;
